export default __webpack_public_path__ + "static/media/laptop-meetcaster.3d898db3.png";